import ProtectedRoute from 'auth/ProtectedRoute';
import ActionsToolbar from 'components/ActionsToolbar';
import AutomaticBillHistoryOverview from 'components/automatic-billiing/AutomaticBillHistoryOverview';
import AutomaticBillingView from 'components/automatic-billiing/AutomaticBillingView';
import AutomaticBillRunView from 'components/automatic-billiing/AutomaticBillRunView';
import BillStornoView from 'components/bill-storno/BillStornoView';
import BillDetails from 'components/bill/BillDetails';
import DocumentCopiesView from 'components/billing/document-copy/DocumentCopiesView';
import CollectiveBillsView from 'components/billing/home-collective-bills/CollectiveBillsView';
import Consultations from 'components/consultations/Consultations';
import MediDataDownloadView from 'components/medidata-download/MediDataDownloadView';
import MediDataNotificationsView from 'components/medidata-notifications/MediDataNotificationsView';
import MediDataUploadView from 'components/medidata-upload/MediDataUploadView';
import PatientEmailsView from 'components/patient-emails/PatientEmailsView';
import Patient from 'components/patient/Patient';
import AutomaticPaymentView from 'components/payment/automatic/AutomaticPaymentView';
import ManualPaymentView from 'components/payment/ManualPaymentView';
import Procedures from 'components/procedures/Procedures';
import AutomaticBillReminderView from 'components/reminder/AutomaticBillReminderView';
import ManualBillReminderView from 'components/reminder/ManualBillReminderView';
import TreatmentInformation from 'components/TreatmentInformation';
import TreatmentOverview from 'components/treatmentoverview/TreatmentOverview';
import Treatments from 'components/treatments/Treatments';
import React, { Fragment } from "react";
import { Switch } from "react-router";
import styled from 'styled-components';
import { StornoType } from 'ts-types/api.enums';

const LeftContent = styled.div`
`;

const RightContent = styled.div`
`;

const MainRightContent = styled.div`
  @media screen and (min-width: 1024px) {
    display: grid;
    grid-template-columns: 40% 59%;
    grid-column-gap: 0.75rem;
  }
`;

const MainComponent = () => (
    <Fragment>
      <ActionsToolbar/>
      <MainRightContent>
        <LeftContent>
          <Patient isHome={true}/>
          <Treatments/>
          <Consultations/>
        </LeftContent>
        <RightContent>
          <Procedures/>
          <TreatmentInformation/>
          <BillDetails/>
        </RightContent>
      </MainRightContent>
    </Fragment>
);

const HomeContent = () => (
    <Fragment>
      <Switch>
        <ProtectedRoute path="/storno/bill" component={() => <BillStornoView stornoType={StornoType.BILL}/>}/>
        <ProtectedRoute path="/storno/payment" component={() => <BillStornoView stornoType={StornoType.PAYMENT}/>}/>
        <ProtectedRoute path="/automatic-payment" component={AutomaticPaymentView}/>
        <ProtectedRoute path="/manual-payment" component={ManualPaymentView}/>
        <ProtectedRoute path="/manual-reminder" component={ManualBillReminderView}/>
        <ProtectedRoute path="/automatic-reminder" component={AutomaticBillReminderView}/>
        <ProtectedRoute path="/automatic-billing/run-data" exact component={AutomaticBillRunView}/>
        <ProtectedRoute path="/automatic-billing/run-data/:runId" component={AutomaticBillHistoryOverview}/>
        <ProtectedRoute path="/automatic-billing" component={AutomaticBillingView}/>
        <ProtectedRoute path="/medidata-upload" component={MediDataUploadView}/>
        <ProtectedRoute path="/medidata-download" component={MediDataDownloadView}/>
        <ProtectedRoute path="/medidata-notifications" component={MediDataNotificationsView}/>
        <ProtectedRoute path="/document-copies" component={DocumentCopiesView}/>
        <ProtectedRoute path="/treatment-overview" component={TreatmentOverview}/>
        <ProtectedRoute path="/collective-bills" component={CollectiveBillsView}/>
        <ProtectedRoute path="/patient-emails" component={PatientEmailsView}/>
        <ProtectedRoute component={MainComponent}/>
      </Switch>
    </Fragment>
);

export default HomeContent;
